import React from 'react'

const KeyValue = ({title, value, value2, value3, colSpan = 1 }) => {

  return (
    <div colSpan={colSpan} className="readonly-container">
      <div className="readonly-label">{title}</div>
      <div className="readonly-text">{value}</div>
      {value2 && <div className="readonly-text">{value2}</div>}
      {value3 && <div className="readonly-text">{value3}</div>}
    </div>
  )
}

export default KeyValue
